import "./Layout.scss";
import React from "react";
import Header from "./Header/Header";
import Footer from "./Footer/Footer";

const Layout = ({ children }) => {
  return (
    <div className={"landing"}>
      <Header />
      <main className="global_main">{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;
